import { configureStore } from "@reduxjs/toolkit";
import alertsSlice from "../features/alertsSlice";
import formsSlice from "../features/formsSlice";
import globalSlice from "../features/globalSlice";
import loadingSlice from "../features/loadingSlice";
import productsSlice from "../features/productsSlice";
import storageSlice from "../features/storageSlice";
import userSlice from "../features/userSlice";

export const store = configureStore({
  reducer: {
    global: globalSlice,
    user: userSlice,
    products: productsSlice,
    forms: formsSlice,
    alerts: alertsSlice,
    loading: loadingSlice,
    localStorage: storageSlice,
  },
});
